<script lang="ts">
  import { breadcrumbs } from "../lib/breadcrumbs";
  type Props = {
    type?: "dark" | "light";
  };

  const { type = "dark" }: Props = $props();
  let items = breadcrumbs.active;
</script>

<nav class="px-8 whitespace-nowrap">
  {#each $items as { label, url }, index (index)}
    {#if index > 0}
      <span class="breadcrumb-separator">/</span>
    {/if}
    {#if url}
      <a
        href={url}
        class="breadcrumb-link"
        class:dark-text={type === "dark"}
        class:light-text={type === "light"}
      >{label}</a>
    {:else}
      <span>{label}</span>
    {/if}
  {/each}
</nav>

<style lang="postcss">
  .breadcrumb-link {
    @apply underline text-[#89a3a5] last:text-white hover:text-[#e1e1e1]
      text-sm;

    :global(.dark) & {
      @apply text-[#aeaeae] last:text-white hover:text-white;
    }
  }
</style>
